const parseTextToHtml = (input: string, removeBrTag = false): string  => {
    if (!input || input === 'undefined') {
        return '';
    }

    let text = input.trim();

    // Step 1: decode escaped characters safely
    text = parseEncodedText(text);

    // Step 2: extract body safely
    text = extractBody(text);

    // Step 3: handle new line
    if (text.trim()) {
        text = text.replace(/\r?\n/g, removeBrTag ? ' ' : '<br>');
    }

    // Step 4: sanitize HTML
    text = parseAndSanitizeHtml(text);

    // Step 5: Remove unwanted known tags
    text = text
        .replace(/<grok:[^>]*>[\s\S]*?<\/grok:[^>]*>/gi, '')
        .replace(/<\/?grok:[^>]*>/gi, '')
        .replace(/<argument[^>]*>[\s\S]*?<\/argument>/gi, '')
        .replace(/<\/?argument[^>]*>/gi, '')
        .replace(/<\/?title>/gi, '');

    // Step 6: Normalize <br> tags: remove leading/trailing/multiple consecutive
    text = text
        .replace(/^(?:\s*<br\s*\/?>\s*)+/gi, ' ') // leading
        .replace(/(?:\s*<br\s*\/?>\s*)+$/gi, ' ') // trailing
        .replace(/(<br\s*\/?>\s*){2,}/gi, '<br>'); // consecutive

    // Step 7: Remove content in square brackets
    text = text.replace(/\[[^\]]*\]/g, '');

    return text.trim();
};

const parseEncodedText =(input: string): string => {
    if (!input) {
        return '';
    }

    let text = input;
    try {
        text = JSON.parse(`"${text}"`);
    } catch {
        text = text
            .replace(/\\n/g, '\n')
            .replace(/\\"/g, '"')
            .replace(/\\'/g, "'")
            .replace(/\\\\/g, '\\');
    }
    return text;
};

const parseAndSanitizeHtml = (input: string): string => {
    let text = input?.trim?.() ?? '';

    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        doc.querySelector('head')?.remove();

        doc.querySelectorAll('[style]').forEach(el =>
            el.removeAttribute('style')
        );

        const blockTags = new Set([
            'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
            'DIV', 'UL', 'OL', 'LI',
            'BLOCKQUOTE', 'PRE', 'TABLE', 'THEAD', 'TBODY',
            'TR', 'TD', 'TH',
            'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'NAV', 'ASIDE'
        ]);

        const isBlock = (node: Node | null): boolean =>
            node?.nodeType === Node.ELEMENT_NODE &&
            blockTags.has((node as Element).tagName);

        const nearestSibling = (node: Node, forward: boolean): Node | null => {
            let n: Node | null = forward ? node.nextSibling : node.previousSibling;

            while (n?.nodeType === Node.TEXT_NODE && !n.textContent?.trim()) {
                n = forward ? n.nextSibling : n.previousSibling;
            }

            return n;
        };

        for (const br of Array.from(doc.querySelectorAll('br'))) {
            if (isBlock(nearestSibling(br, false)) || isBlock(nearestSibling(br, true))) {
                br.remove();
            }
        }

        text = doc.body?.innerHTML ?? '';

    } catch {
        return text;

    }

    return text.trim();
};


const extractBody = (text: string): string => {
    const match = text.match(/<body[^>]*>([\s\S]*?)<\/body>/i);

    if (match) {
        return match[1];
    }

    // if body tag is broken
    const fallback = text.match(/<body[^>]*>([\s\S]*)/i);
    return fallback ? fallback[1] : text;
};

export { parseTextToHtml };
